/* eslint-disable import/prefer-default-export */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { ICourseForAdmin, TUpdateCourseAsAdmin } from '../CoursesSlice';
import { AdminApiPaths } from '../../../api/APIPaths';
import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';
import { ISectionForAdmin, TUpdateCourseSectionAsAdmin } from '../SectionSlice';

const apiDataProvider = new APIDataProvider();

export const updateCourseAsAdminSavingSlice = createAsyncThunk(
  '/admin/saving/courses/updateOne',
  async ({ _id, ...data }: TUpdateCourseAsAdmin) => {
    const path = `${AdminApiPaths.courses}/${_id}`;
    const response = await apiDataProvider.put<TApiResponse<ICourseForAdmin>>(
      path,
      data
    );

    return response.data;
  }
);

export const updateCourseSectionAsAdminSavingSlice = createAsyncThunk(
  '/admin/saving/sections/update',
  async ({ _id, ...data }: TUpdateCourseSectionAsAdmin) => {
    const path = `${AdminApiPaths.sections}/${_id}`;
    const response = await apiDataProvider.put<TApiResponse<ISectionForAdmin>>(
      path,
      data
    );

    return response.data;
  }
);
